import moment from 'moment';

export default class DateUtil {

    /**
     * @param {string} localDateTimeString string with format YYYY-MM-DDTHH:mm:ss.SSS
     * @returns {?Moment}
     */
    public static localDateTimeToMoment(localDateTimeString: string | null | undefined): moment.Moment | undefined {
        if (!localDateTimeString) {
            return undefined;
        }
        let theMoment: moment.Moment = moment(localDateTimeString, ['YYYY-MM-DDTHH:mm:ss.SSS', 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm:ss.SSSZ'], true);
        return theMoment.isValid() ? theMoment : undefined;
    }

    /**
     * Calls momentToLocalDateFormat with the format by default 'YYYY-MM-DD'
     * @param aMoment
     * @returns {string}
     */
    public static momentToLocalDate(aMoment: moment.Moment): string | undefined {
        return DateUtil.momentToLocalDateFormat(aMoment, 'YYYY-MM-DD');
    }

    /**
     * @param {Moment} aMoment time instance
     * @param format format to use
     * @returns {?string} a Date (YYYY-MM-DD) representation of the given moment. NULL when aMoment is invalid
     */
    public static momentToLocalDateFormat(aMoment: moment.Moment, format: string): string | undefined {
        if (!aMoment) {
            return undefined;
        }
        return moment(aMoment).startOf('day').format(format);
    }

    /**
     * @param {Moment} aMoment time instance
     * @param format format for the time
     * @returns {?string} a Date (YYYY-MM-DD) representation of the given moment. undefined when aMoment is invalid
     */
    private static momentToLocalDateTimeFormat(aMoment: moment.Moment, format: string): string | undefined {
        if (!aMoment) {
            return undefined;
        }
        return moment(aMoment).format(format);
    }

    /**
     * @param {Moment} aMoment time instance
     * @returns {?string} a Date (YYYY-MM-DD) representation of the given moment. NULL when aMoment is invalid
     */
    public static momentToLocalDateTime(aMoment: moment.Moment): string | undefined {
        return DateUtil.momentToLocalDateTimeFormat(aMoment, 'YYYY-MM-DDTHH:mm:ss.SSS');
    }

    /**
     * @param {string} localDateString string with format YYYY-MM-DD
     * @returns {?moment}
     */
    public static localDateToMoment(localDateString: string): moment.Moment | undefined {
        let theMoment = moment(localDateString, 'YYYY-MM-DD', true);
        return theMoment.isValid() ? theMoment : undefined;
    }

    public static today(): moment.Moment {
        return moment().startOf('day');
    }

    public static now(): moment.Moment {
        return moment();
    }

    public static currentYear(): number {
        return moment().year();
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/DateUtil.ts